import httpService from './httpService';
import { ExternalCalendar } from './model/calendarConnection.model';
import { EventType, NotificationSettings } from '../types/event';

async function importEvent(
  icsContent: string, 
  participantsIds: number[] = [], 
  inviteAll = true,
  eventType?: EventType,
  notificationSettings?: NotificationSettings,
  attendanceRequired?: boolean
): Promise<void> {
  return httpService.post(`/calendar/import`, { 
    icsContent, 
    participantsIds, 
    inviteAll, 
    eventType, 
    notificationSettings,
    attendanceRequired
  });
}

async function createExternalCalendar(
  url: string, 
  eventType?: EventType, 
  notificationSettings?: NotificationSettings,
  participantsIds?: number[],
  inviteAll?: boolean,
  attendanceRequired?: boolean
): Promise<number> {
  const { data } = await httpService.post(`/calendar/external`, { 
    url, 
    eventType, 
    notificationSettings,
    participantsIds,
    inviteAll,
    attendanceRequired
  });
  return data;
}

async function deleteExternalCalendar(id: string | number): Promise<void> {
  const { data } = await httpService.delete(`/calendar/external/${id}`);
  return data;
}

async function getExternalCalendars(): Promise<ExternalCalendar[]> {
  const { data } = await httpService.get(`/calendar/external`);
  return data;
}

async function fetchExternalCalendar(id: string | number): Promise<any> {
  const { data } = await httpService.put(`/calendar/external/${id}/fetch`);
  return data;
}

export default {
  importEvent,
  createExternalCalendar,
  deleteExternalCalendar,
  getExternalCalendars,
  fetchExternalCalendar
}